import '../../Assets/Styles/home.css';
import '../../Assets/Styles/order.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Link,UNSAFE_DataRouterStateContext,useNavigate} from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Grid from '@mui/material/Grid';

import moment from "moment";

// Load Actions
import * as AppActions from '../../Store/Actions/App'
import * as PartnerActions from '../../Store/Actions/Partner'

import HeaderView from '../../Components/Layout/Header';

// Load Componentes
import SideMenu from '../../Components/SideMenu';
import LeadModal from './LeadModal';

import {
	validarCNPJ,
	validarCPF,
	validarEmail,
	validarTelefone,
	validarNome,
	maskCNPJ,
	maskCPF,
	maskPhone,
	isJsonString,
	toJsonOrEmpty,	
} from '../../Components/Utils';


// export default function Reservation() {
const Leads = (props) => {
	
  const {
    setDialog,
    dialog,
    setLead,              // setter no store (ou local) para o lead selecionado
    retrieveLeads,        // action
    retrieveLead,         // action (detalhe)
    masterUser,
    userRights
  } = props;

// Set Overlay obj
const op = React.useRef(null);

const [loading, setLoading] = React.useState(true); 
const [saving, setSaving] = React.useState(false); 
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isSpecialDesktop = useMediaQuery({ query: '(max-width: 1500px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

const [stillConnected, setStillConnected] = React.useState(false);
const onStillConnectedChange = (e) => {
	if (e.checked)
		setStillConnected(true);
	else
		setStillConnected(false);
}  // end function
	
// Alert control
const [alert, setAlert] = React.useState(false); 
const [alertTitle, setAlertTitle] = React.useState("Informações"); 
const [alertBody, setAlertBody] = React.useState("Conteúdo dinâmico"); 

// Basic filter fields  and controls
const [basicFilterStatus, setBasicFilterStatus] = React.useState(false);
const [basicFilter, setBasicFilter] = React.useState({});
const [filterValue, setFilterValue] = React.useState("");

// Advanced filter fields and controls
const [advancedFilterStatus, setAdvancedFilterStatus] = React.useState(false);
const [advancedFilter, setAdvancedFilter] = React.useState({});
const [advancedSearch, setAdvancedSearch] = React.useState(false);

// CUSTOM ADVANCED FILTER FIELDS
const [filterByTradingName, setFilterByTradingName] = React.useState("");
const [filterByAgencyName, setFilterByAgencyName] = React.useState("");
const [filterByAgencyDocument, setFilterByAgencyDocument] = React.useState("");
const [filterByResponsibleName, setFilterByResponsibleName] = React.useState("");
const [filterByResponsibleDocument, setFilterByResponsibleDocument] = React.useState("");
const [filterByAgencyPhone, setFilterByAgencyPhone] = React.useState("");
const [filterByAgencyEmail, setFilterByAgencyEmail] = React.useState("");
const [filterByCreateAtFrom, setFilterByCreateAtFrom] = React.useState("");
const [filterByCreateAtTo, setFilterByCreateAtTo] = React.useState("");

  // Advanced search
  const [filterByCustomerName, setFilterByCustomerName] = React.useState('');
  const [filterByCustomerDocument, setFilterByCustomerDocument] = React.useState('');
  const [filterByCustomerEmail, setFilterByCustomerEmail] = React.useState('');
  const [filterByCustomerPhone, setFilterByCustomerPhone] = React.useState('');
  const [filterByTargetType, setFilterByTargetType] = React.useState([]);
  const [filterByType, setFilterByType] = React.useState([]);
  const [filterByServiceOrDiscount, setFilterByServiceOrDiscount] = React.useState(null);
  

const [filterByComissionProfile, setFilterByComissionProfile] = React.useState(null);
const [filterByStatus, setFilterByStatus] = React.useState(null);
const [filterByAgencyState, setFilterByAgencyState] = React.useState(null);
const [filterByAgencyCity, setFilterByAgencyCity] = React.useState("");

// Dropdown Options Advanced filter
const [agenciesStatesOptions, setAgenciesStatesOptions] = React.useState([]);
const [comissionProfilesOptions, setComissionProfilesOptions] = React.useState([]);

// Table row selection
const [selectedItem, setSelectedItem] = React.useState(null);

// Set Fake Data
//var rowsData = ReservationData;
const [rows, setRows] = React.useState([]);
const [totalRecords, setTotalRecords] = React.useState(0);
 
/* -------------------------------- */ 
/* Custom methods and options START */
/* -------------------------------- */

  // -----------------------------
  // Seleciona lead e abre modal
  // -----------------------------
  const selectLeadAction = (value) => {
    const normalizedValue = Array.isArray(value) ? value : [value];
    const lead = normalizedValue?.[0] || null;

    setLead(lead);

console.log('[LEAD]--------->]'+JSON.stringify(lead, null, 2));

    setDialog('leadModal', true);
  };


// -----------------------------
  // Retrieve list
  // -----------------------------
  const retrieveItemsList = () => {

	var props = {
		setSaving:setSaving,
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setRows:setRows,
		setLoading:setLoading,
		setTotalRecords:setTotalRecords
	}
	var data = {
	  ...lazyState,
	  status:[0,1,2] // Set to retrieve only those status
	}

    retrieveLeads(data, props);
  };

// Retrieve dropdown valures from API
const retrieveDropdownsValues = () => {
		
	/*var props = {
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setRows:setAgenciesStatesOptions,
		setLoading:setLoading,
	}
	var data = {
	}
	retrieveAgenciesStates(data,props);

	var props = {
		setAlert:setAlert,
		setAlertTitle:setAlertTitle,
		setAlertBody:setAlertBody,
		setRows:setComissionProfilesOptions,
		setLoading:setLoading,
	}
	var data = {
	}
	retrieveAgenciesComissionProfiles(data,props);*/

} // end retrieveDropdownsValues

// Dropdown Values for Basic Search Fields
  const [filter, setFilter] = React.useState({
    code: '1',
    field: 'customerName',
    name: 'Nome do Cliente'
  });
  
// Basic filter fields
const FilterItems = [
	{ code: '1', field: 'customerName', name: 'Nome do Cliente' },
	{ code: '2', field: 'customerDocument', name: 'CPF do Cliente' }
];
const [dropdownFilterItems, setDropdownFilterItems] = React.useState(FilterItems);

  const LeadStatusOptions = [
    { code: 0, name: 'Não visualizado' },
    { code: 1, name: 'Visualizado' },
    { code: 2, name: 'Outro' }
  ];

  const TargetTypeOptions = [
    { code: 'own', name: 'Próprio' },
    { code: 'thirdparty', name: 'Terceiro' }
  ];

  const LeadTypeOptions = [
    { code: 'service', name: 'Serviço' },
    { code: 'discount', name: 'Desconto' }
  ];


const formatBRL = (value) => {
    const v = Number(value || 0);
    return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const statusSeverity = (status) => {
    if (Number(status) === 1) return 'success';
    if (Number(status) === 0) return 'warning';
    return 'info';
  };

  const statusLabel = (status) => {
    const s = Number(status);
    if (s === 0) return 'Não visualizado';
    if (s === 1) return 'Visualizado';
    return 'Outro';
  };  

// Datatable default state
const [lazyState, setlazyState] = React.useState({
	first: 0,
	rows: 10,
	page: 1,
	sortField: "createdAt",
	sortOrder: -1,
	filters: {}
}); 

// Default columns
const columnsValues = [
'agencyId',
'agency',
'responsible',
'contacts',
'location',
'profile',
'createdAt',
'status'
];
const [visibleColumns, setVisibleColumns] = React.useState(columnsValues);

// Field value format and enrichement
const bodyTemplate_ = (type,data) => {

	let rowValue = "Não definido";

	if (type == "agencyId") {

		rowValue = (
		<>
		<div>{data.id}</div>
		</>
		);	
		
	}
	
	if (type == "agency") {		

		rowValue = (
		<>
		<div>{data.companyName}
		
		{/* Set Master Agency Icon */}
		{data.type == 2 &&
		<>
			<svg fill="#814DE5" title="Empresa Master" viewBox="0 0 1920 1920" width="15" height="15" style={{}}  xmlns="http://www.w3.org/2000/svg" stroke="#814DE5"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M983.727 5.421 1723.04 353.62c19.765 9.374 32.414 29.252 32.414 51.162v601.525c0 489.6-424.207 719.774-733.779 887.943l-34.899 18.975c-8.47 4.517-17.731 6.889-27.105 6.889-9.262 0-18.523-2.372-26.993-6.89l-34.9-18.974C588.095 1726.08 164 1495.906 164 1006.306V404.78c0-21.91 12.65-41.788 32.414-51.162L935.727 5.42c15.134-7.228 32.866-7.228 48 0ZM757.088 383.322c-176.075 0-319.285 143.323-319.285 319.398 0 176.075 143.21 319.285 319.285 319.285 1.92 0 3.84 0 5.76-.113l58.504 58.503h83.689v116.781h116.781v83.803l91.595 91.482h313.412V1059.05l-350.57-350.682c.114-1.807.114-3.727.114-5.647 0-176.075-143.21-319.398-319.285-319.398Zm0 112.942c113.732 0 206.344 92.724 205.327 216.62l-3.953 37.271 355.426 355.652v153.713h-153.713l-25.412-25.299v-149.986h-116.78v-116.78H868.108l-63.812-63.7-47.209 5.309c-113.732 0-206.344-92.5-206.344-206.344 0-113.732 92.612-206.456 206.344-206.456Zm4.98 124.98c-46.757 0-84.705 37.948-84.705 84.706s37.948 84.706 84.706 84.706c46.757 0 84.706-37.948 84.706-84.706s-37.949-84.706-84.706-84.706Z" fill-rule="evenodd"></path> </g></svg>	
		</>
		}			
		
		</div>
		<div style={{color:"gray"}}>{data.tradingName}</div>
		<div><small style={{color:"gray"}}>{data.CompanyDocument.formattedValue}</small></div>
		</>
		);	
		
	}
	
	if (type == "responsible") {	
			
		rowValue = (
		<>
		<div>{data.completeName}</div>
		<div><small style={{color:"gray"}}>{data.CompanyPersonDocuments[0].formattedValue}</small></div>
		</>
		);				
	}	
	
	if (type == "contacts") {
		
		rowValue = (
		<>
		<div>{maskPhone(data.phone)}</div>
		<div><small style={{color:"gray"}}>{data.email}</small></div>
		</>
		);			
	}	

	if (type == "location") {		
	
		rowValue = (
		<>
		<div>{data.StateLabel}</div>
		<div><small style={{color:"gray"}}>{data.CityLabel}</small></div>
		</>
		);
	}	

	if (type == "governmentData") {		

		let cnaeItem = data.find(item => item.key === "cnae");
		const cnaeData = isJsonString(cnaeItem.value) ? toJsonOrEmpty(cnaeItem.value) : "Não definido";
		
		let situacaoItem = data.find(item => item.key === "situacao");
		const situacaoData = isJsonString(situacaoItem.value) ? toJsonOrEmpty(situacaoItem.value) : "Não definido";
		
		let porteItem = data.find(item => item.key === "porte");
		const porteData = isJsonString(porteItem.value) ? toJsonOrEmpty(porteItem.value) : "Não definido";		

		rowValue = (
			<>
			  <div>{porteData.descricao}</div>
			  <div><small style={{color:"gray"}}>{situacaoData.nome} desde {situacaoData.data}</small></div>
			  <div><small style={{color:"gray"}}>CNAE {cnaeData.subClasse}<br />{cnaeData.descricao}</small></div>
			</>
		);			

	}		
	
	if (type == "creationDate") {		
		rowValue = moment(data.createdAt).format("DD/MM/YYYY")
	}	

	if (type == "profile") {
	
		rowValue = (
		<>
		<div>{data.CompanyComissionGroup.name} ({data.CompanyComissionGroup.alias})</div>
		<div>{data.CompanyProfileGroup.name}</div>

		{/* Set Master Agency Icon */}
		{data.type == 2 &&
		<>
			<div><small style={{color:"gray"}}>Empresa Master</small></div>
		</>
		}	

		</>
		);		
		
	}	

	if (type == "status") {		

		if (data.status == 1) {
			var activationStatus = "ativado";
			var activationStatusLabel = "Aprovada";
		} // end if
		else if (data.status == 2) {
			var activationStatus = "bloqueado";
			var activationStatusLabel = "Reprovada";
		} // end if	
		else if (data.status == 3) {
			var activationStatus = "encerrado";
			var activationStatusLabel = "Bloqueado";
		} // end if			
		else if (data.status == 4) {
			var activationStatus = "encerrado";
			var activationStatusLabel = "Cancelado";
		} // end if			 
		else if (data.status == 0) {
			var activationStatus = "review";
			var activationStatusLabel = "Aguardando análise";
		} // end if	
		else if (data.status == 9) {
			var activationStatus = "encerrado";
			var activationStatusLabel = "Excluído";
		} // end if
				
			
		return (
		<>
		<div className={`product-badge status-${activationStatus}`}>{activationStatusLabel}</div>
		</>
		)	
	
		rowValue = data;
	}	
	
    return rowValue;
};


  // -----------------------------
  // Body templates
  // -----------------------------
  const bodyTemplate = (type, rowData) => {
    if (type === 'createdAt') {
      const dt = rowData?.createdAt ? new Date(rowData.createdAt) : null;
      return dt ? dt.toLocaleString('pt-BR') : '-';
    }

    if (type === 'status') {
      return (
        <Tag
          value={statusLabel(rowData?.status)}
          severity={statusSeverity(rowData?.status)}
        />
      );
    }

    if (type === 'customerName') return rowData?.customer?.name || '-';
    if (type === 'customerDocument') return rowData?.customer?.document || '-';

    if (type === 'serviceOrDiscount') {
      const sd = rowData?.serviceOrDiscount || null;
      if (!sd) return '-';
      const label = sd?.name ? sd.name : '(sem nome)';
      const t = sd?.type ? (sd.type === 'service' ? 'Serviço' : 'Desconto') : '—';
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <span style={{ fontWeight: 600 }}>{label}</span>
          <small style={{ opacity: 0.7 }}>{t}</small>
        </div>
      );
    }

    if (type === 'perLeadPrice') return formatBRL(rowData?.pricing?.perLeadPrice);

    if (type === 'city') {
      const city = rowData?.customerAddress?.city || '';
      const st = rowData?.customerAddress?.state || '';
      const text = [city, st].filter(Boolean).join(' / ');
      return text || '-';
    }

    if (type === 'targetType') {
      const tt = rowData?.targetType;
      if (tt === 'own') return 'Próprio';
      if (tt === 'thirdparty') return 'Terceiro';
      return '-';
    }

    return '-';
  };
 
const applyBasicSearch = () => {
	
	// Check if search term is filled and with at least 3 chars
	if (!filterValue) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Você precisa preencher o termo a ser buscado pra prosseguir.");	
		return;
	} // end if
	
	if (filterValue.length < 3) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Para prosseguir, você precisa preencher o termo a ser buscado com ao menos 3 caracteres.");	
		return;
	} // end if	
 	
	// Set filter on
	setBasicFilterStatus(true);
	
	// Set advanced filter off
	setAdvancedFilterStatus(false);
	
	// Clean Advanced fields
	// Métodos que atualizam os estados para uma string vazia
	setFilterByTradingName("");
	setFilterByAgencyName("");
	setFilterByAgencyDocument("");
	setFilterByResponsibleName("");
	setFilterByResponsibleDocument("");
	setFilterByAgencyPhone("");
	setFilterByAgencyEmail("");  // Mantendo como array vazio, conforme inicialização original
	setFilterByCreateAtFrom("");
	setFilterByCreateAtTo("");
	setFilterByAgencyCity("");

	// Métodos que atualizam os estados para null (mantendo o tipo original)
	setFilterByComissionProfile(null);
	setFilterByStatus(null);
	setFilterByAgencyState(null);
	
	// Set filter to lazyData
	var currentData = {...lazyState}
	
	// Set current filter
	currentData.filters = {
		mode:"basic",
		term: filterValue,
		field: filter
	}
	
	// Set LazyState
	setlazyState(currentData);
	
} // end function

const resetSearch = (type)=> {
	
	if (type == "basic") {
		// Set filter on
		setBasicFilterStatus(false);
		
		// Clean Terms
		setFilterValue("");		
	} // end if
	else {
		// Set filter on
		setAdvancedFilterStatus(false);
		
		// Métodos que atualizam os estados para uma string vazia
		setFilterByTradingName("");
		setFilterByAgencyName("");
		setFilterByAgencyDocument("");
		setFilterByResponsibleName("");
		setFilterByResponsibleDocument("");
		setFilterByAgencyPhone("");
		setFilterByAgencyEmail("");  // Mantendo como array vazio, conforme inicialização original
		setFilterByCreateAtFrom("");
		setFilterByCreateAtTo("");
		setFilterByAgencyCity("");

		// Métodos que atualizam os estados para null (mantendo o tipo original)
		setFilterByComissionProfile(null);
		setFilterByStatus(null);
		setFilterByAgencyState(null);	
		
	} // end else
	
	// Set filter to lazyData
	var currentData = {...lazyState}
	
	// Set current filter
	currentData.filters = {};
	
	// Set LazyState
	setlazyState(currentData);	
	
} // end fucntion

const applyAdvancedSearch = () => {
	
	// Check if at least one field is filled
	if (!filterByTradingName && !filterByAgencyName && !filterByAgencyDocument && !filterByResponsibleName && !filterByResponsibleDocument && !filterByAgencyPhone &&  !filterByAgencyEmail && !filterByCreateAtFrom && !filterByCreateAtTo && 	!filterByComissionProfile && !filterByStatus && !filterByAgencyState && !filterByAgencyCity) {
		setAlert(true);
		setAlertTitle("Verifique as informações");
		setAlertBody("Você precisa preencher ao menos um campo pra prosseguir com a busca.");	
		return;
	} // end if	
	
	// Check if createdAt From and To are filled 
	if (filterByCreateAtFrom || filterByCreateAtTo) {
		if (!filterByCreateAtFrom || !filterByCreateAtTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data de criação para prosseguir.");	
			return;
		}
	} // end if

	// Check if createdAt From and To are filled 
	if (filterByCreateAtFrom || filterByCreateAtTo) {
		if (!filterByCreateAtFrom || !filterByCreateAtTo) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("Você precisa preencher ao os dois campos da data do serviço para prosseguir.");	
			return;
		}
	} // end if	
	
	// Check company document if ok
	if (filterByResponsibleDocument) {
		if (!validarCPF(filterByResponsibleDocument)) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("O CPF informado é inválido. Verifique novamente.");		
			return;
		}
	} // end if	

	// Check customer document if ok
	if (filterByAgencyDocument) {
		if (!validarCNPJ(filterByAgencyDocument)) {
			setAlert(true);
			setAlertTitle("Verifique as informações");
			setAlertBody("O CNPJ informado é inválido. Verifique novamente.");	
			return;
		}
	} // end if		
	 	
	// Set filter on
	setBasicFilterStatus(false);
	
	// Clean Basic Search term
	setFilterValue("");
	
	// Set advanced filter off
	setAdvancedFilterStatus(true);
	
	// Set filter to lazyData
	var currentData = {...lazyState}	
	
	var filters = {};
	filters.mode = "advanced"; 
	filters.agencyTradingName = filterByTradingName ? filterByTradingName : null; 
	filters.agencyName = filterByAgencyName ? filterByAgencyName : null; 
	filters.agencyDocument = filterByAgencyDocument ? filterByAgencyDocument : null; 
	filters.responsibleName = filterByResponsibleName ? filterByResponsibleName : null; 
	filters.responsibleDocument = filterByResponsibleDocument ? filterByResponsibleDocument : null; 
	filters.agencyPhone = filterByAgencyPhone ? filterByAgencyPhone : null; 
	filters.agencyEmail = filterByAgencyEmail ? filterByAgencyEmail : null; 
	filters.createAtFrom = filterByCreateAtFrom ? filterByCreateAtFrom : null; 
	filters.createAtTo = filterByCreateAtTo ? filterByCreateAtTo : null; 
	filters.agencyState = filterByAgencyState ? filterByAgencyState : null; 
	filters.agencyCity = filterByAgencyCity ? filterByAgencyCity : null; 
	filters.comissionProfile = filterByComissionProfile ? filterByComissionProfile : null; 
	filters.status = filterByStatus ? filterByStatus : null; 

	
	// Apply filter on Data from service 
	let _lazyParams = { ...lazyState, filters:{ fields: filters, mode:"advanced" } };
	setlazyState(_lazyParams);	
	
	// Closes panel
	setAdvancedSearch(!advancedSearch)
	
} // end function
 
/* -------------------------------- */ 
/* Custom methods and options END */
/* -------------------------------- */
 
 
/* -------------------- */ 
/* Common methods START */
/* -------------------- */

// Set selected columns
const onColumnsChange = (e) => {
	
	let _visibleColumns = [...visibleColumns];

	if (e.checked)
		_visibleColumns.push(e.value);
	else
		_visibleColumns.splice(_visibleColumns.indexOf(e.value), 1);

	setVisibleColumns(_visibleColumns);
}

// Datatable related controls START
const loadLazyData = () => {	
	setLoading(true);
	retrieveItemsList();	
};

// Run after mount component
React.useEffect(() => {

  // set scroll to top
  window.scrollTo(0, 1);
  
  // Load list
  retrieveItemsList();

  // Load dropdown values for advanced filter 
  retrieveDropdownsValues();  
      
  // Runs when UNMOUNT component
  return () => {
    
	// unmount...	
	
  };
  
}, []); // end useEffect 

const onPage = (event) => {	
	setlazyState(event);
};

const onSort = (event) => {
	setlazyState(event);
};

const onFilter = (event) => {
	event['first'] = 0;
	setlazyState(event);
};
// Datatable related controls END

// Reacts when lazyState changes
React.useEffect(() => {
	loadLazyData();
}, [lazyState]);
 
// Set Currency format
let EURO = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'EUR',
});

// Set calendar locale
addLocale('br', {
	firstDayOfWeek: 1,
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar'
});

// set Use of history for PUSH 
var navigate = useNavigate(); 

/* -------------------- */ 
/* Common methods END */
/* -------------------- */
 
  return (
	<>
	<div id="adminSection" style={{marginTop:"0"}} className={isTabletOrMobile ? "login__wrapper mobile" : "login__wrapper"} >
		<div style={{height:"auto"}} className={isTabletOrMobile ? "login__wrapper_form_wrapper mobile" : "login__wrapper_form_wrapper"}> 

			<HeaderView isOnAdmin={true} />

			<div className={isTabletOrMobile ? "login__form_wrapper mobile" : "login__form_wrapper"} style={{alignItems:"flex-start",marginTop:"6rem"}}>
						
				<div style={{flex:1,display:"flex",flexDirection:isMobile ? "column" : "row",justifyContent:"center",alignItems:"flex-start",gap:"10px",padding:isMobile ? "10px" : "40px",marginTop:"04x",height:"auto",marginLeft:"auto",marginRight:"auto",width:"100%",border:"0px solid red"}}>
				
						{/* Admin Side Menu */}
						<SideMenu state="open" />
						
						{/* Admin Content */}
						<div style={{flex:1,height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
						
							<div style={{height:isMobile ? "" : "64px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
							
								<div style={{textAlign:"left",flex:1,color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '36px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Direcionamentos</div>
								
								<div style={{flex:3,display:"flex",flexDirection:"row",justifyContent:"end",alignItems:"center"}}>
								
									<div style={{padding:"10px",marginRight:"10px",fontSize:"14px"}}>  Filtrar a busca por: </div>
									<div style={{backgroundColor:"#FFF",padding:"10px",borderTopLeftRadius:"20px",borderBottomLeftRadius:"20px"}}> 
										<Dropdown id="filterOption" disabled={saving} value={filter} onChange={(e) => setFilter(e.value)} options={dropdownFilterItems} optionLabel="name" placeholder="Selecione o campo" style={{minWidth:isSpecialDesktop ? "200px" : "230px",textAlign:"left",fontSize:"14px"}} className="w100"></Dropdown>
									</div>
									<div style={{backgroundColor:"#FFF",padding:"10px"}}> 
										<div style={{display:"flex",flexDirection:"row",justifyContent:"flex-start",alignItems:"center"}}>
											<InputText id="filterValue" autoComplete="new-password" disabled={saving}  value={filterValue} onChange={(e) => setFilterValue(e.target.value)} placeholder="Termo da busca" tooltip="Digite o termo a ser buscado" tooltipOptions={{position: 'bottom',event: 'focus'}}  style={{borderTopRightRadius:0,borderBottomRightRadius:0,fontSize:"14px"}} />
											<Button labell="Buscar" icon="pi pi-search" style={{borderTopLeftRadius:0,borderBottomLeftRadius:0,fontSize:"14px"}} loading={saving} onClick={()=>{applyBasicSearch()}} />
											 
											{basicFilterStatus &&
											<>
												<Button outlined icon="pi pi-times" style={{fontSize:"14px",marginLeft:"5px"}} loading={saving} tooltip="Selecione para limpar a busca" tooltipOptions={{ showDelay: 500, position: 'bottom',event: 'over'}} onClick={()=>resetSearch("basic")} />
											</>
											}
											
									  </div>							
									</div>									
									<div style={{backgroundColor:"#FFF",padding:"10px"}}> 
										<Button className="filterButton" badge={advancedFilterStatus ? <svg viewBox="0 0 24 24" width="12" height="12" style={{position:"absolute",right:"2px",top:"2px"}} fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCaredrediered" stredoke-width="0"></g><g id="SVGRepo_tredaceredCaredrediered" stredoke-linecap="redound" stredoke-linejoin="redound"></g><g id="SVGRepo_iconCaredrediered"> <path d="M19 3H5C3.58579 3 2.87868 3 2.43934 3.4122C2 3.8244 2 4.48782 2 5.81466V6.50448C2 7.54232 2 8.06124 2.2596 8.49142C2.5192 8.9216 2.99347 9.18858 3.94202 9.72255L6.85504 11.3624C7.49146 11.7206 7.80967 11.8998 8.03751 12.0976C8.51199 12.5095 8.80408 12.9935 8.93644 13.5872C9 13.8722 9 14.2058 9 14.8729L9 17.5424C9 18.452 9 18.9067 9.25192 19.2613C9.50385 19.6158 9.95128 19.7907 10.8462 20.1406C12.7248 20.875 13.6641 21.2422 14.3321 20.8244C15 20.4066 15 19.4519 15 17.5424V14.8729C15 14.2058 15 13.8722 15.0636 13.5872C15.1959 12.9935 15.488 12.5095 15.9625 12.0976C16.1903 11.8998 16.5085 11.7206 17.145 11.3624L20.058 9.72255C21.0065 9.18858 21.4808 8.9216 21.7404 8.49142C22 8.06124 22 7.54232 22 6.50448V5.81466C22 4.48782 22 3.8244 21.5607 3.4122C21.1213 3 20.4142 3 19 3Z" fill="#FFF"></path> </g></svg> : ""} badgeClassName={advancedFilterStatus ? "p-badge-secondary" : "hidden"} icon={<svg viewBox="0 0 24 24" height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14 4C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V13M10 4C6.22876 4 4.34315 4 3.17157 5.17157C2 6.34315 2 8.22876 2 12C2 15.7712 2 17.6569 3.17157 18.8284C4.34315 20 6.22876 20 10 20H13" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M10 16H6" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <circle cx="18" cy="17" r="3" stroke="#814DE5" stroke-width="1.5"></circle> <path d="M20.5 19.5L21.5 20.5" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> <path d="M2 10L7 10M22 10L11 10" stroke="#814DE5" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>} outlined severity="secondary" aria-label="Busca avançada" style={{ width:"40px",fontSize:"14px"}} onClick={()=>setAdvancedSearch(!advancedSearch)} /> 
										
									</div>
								
								</div>
							
							</div>

							<div className={!advancedSearch ? "advSearchPanel" : "advSearchPanel animate"} style={{width:"100%",backgroundColor:"whitesmoke",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-start",padding:advancedSearch ? "25px" : "0px"}}>
								
								<div style={{textAlign:"left",color: '#2E0249', fontFamily: 'Titillium Web', fontSize: '26px', fontStyle: 'normal', fontWeight: 600, lineHeight: '120%', letterSpacing: '3.6px',padding:"10px"}}>Busca avançada</div>
								<div style={{textAlign:"left",color: '#000', fontFamily: 'Titillium Web', fontSize: '16px', fontStyle: 'normal', fontWeight: 400, lineHeight: '120%', letterSpacing: '3.6px',paddingTop:"0px",marginBottom:"35px"}}>Preencha um ou mais campos e faça a busca</div>

								<Grid container spacing={4}>

								<Grid item xs={12} md={4}>
									<span className="p-float-label" style={{ width: '100%' }}>
									<InputText value={filterByCustomerName} onChange={(e) => setFilterByCustomerName(e.target.value)} style={{ width: '100%' }} />
									<label>Nome do cliente</label>
									</span>
								</Grid>

								<Grid item xs={12} md={4}>
									<span className="p-float-label" style={{ width: '100%' }}>
									<InputText value={filterByCustomerDocument} onChange={(e) => setFilterByCustomerDocument(e.target.value)} style={{ width: '100%' }} />
									<label>CPF do cliente</label>
									</span>
								</Grid>

								<Grid item xs={12} md={4}>
									<span className="p-float-label" style={{ width: '100%' }}>
									<InputText value={filterByCustomerEmail} onChange={(e) => setFilterByCustomerEmail(e.target.value)} style={{ width: '100%' }} />
									<label>Email</label>
									</span>
								</Grid>

								<Grid item xs={12} md={4}>
									<span className="p-float-label" style={{ width: '100%' }}>
									<InputText value={filterByCustomerPhone} onChange={(e) => setFilterByCustomerPhone(e.target.value)} style={{ width: '100%' }} />
									<label>Telefone</label>
									</span>
								</Grid>

								<Grid item xs={12} md={4}>
									<span className="p-float-label" style={{ width: '100%' }}>
									<MultiSelect
										display="chip"
										showClear
										value={filterByTargetType}
										onChange={(e) => setFilterByTargetType(e.value)}
										options={TargetTypeOptions}
										optionLabel="name"
										placeholder="Selecione"
										style={{ width: '100%' }}
									/>
									<label>Destino</label>
									</span>
								</Grid>

								<Grid item xs={12} md={4}>
									<span className="p-float-label" style={{ width: '100%' }}>
									<MultiSelect
										display="chip"
										showClear
										value={filterByType}
										onChange={(e) => setFilterByType(e.value)}
										options={LeadTypeOptions}
										optionLabel="name"
										placeholder="Selecione"
										style={{ width: '100%' }}
									/>
									<label>Tipo</label>
									</span>
								</Grid>

								<Grid item xs={12} md={4}>
									<span className="p-float-label" style={{ width: '100%' }}>
									<MultiSelect
										display="chip"
										showClear
										value={filterByStatus}
										onChange={(e) => setFilterByStatus(e.value)}
										options={LeadStatusOptions}
										optionLabel="name"
										placeholder="Selecione"
										style={{ width: '100%' }}
									/>
									<label>Status</label>
									</span>
								</Grid>

								  <Grid item xs={12} sm={4}>
									<div className="p-float-label" style={{textAlign:"left"}}>
									<MultiSelect
										display="chip"
										showClear
										value={filterByServiceOrDiscount}
										onChange={(e) => setFilterByServiceOrDiscount(e.value)}
										options={[{"code":1,name:"Consulta com oftalmologia"},{"code":3,name:"Consulta de Catarata"},{"code":9,name:"Cirurgia Refrativa"}]}
										optionLabel="name"
										placeholder="Selecione"
										style={{ width: '100%' }}
									/>										
										<label>Serviço / Desconto</label>
									</div>										
								  </Grid>					

								  <Grid item xs={12} sm={12}>
									<div style={{width:"100%",display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",gap:"20px"}}> 
									
											<div style={{textAlign:"right",flex:1}}>
												<Button label="Limpar busca" icon="pi pi-trash" severity="danger" text onClick={()=>{resetSearch("advanced");setAdvancedSearch(!advancedSearch)}}  />
											</div>												
											
											<Button rounded outlined className="pT10" label="Fechar" onClick={()=>setAdvancedSearch(!advancedSearch)} />
																				
											<Button rounded className="pT10" label="Buscar" loading={saving} disabled={saving} onClick={()=>{applyAdvancedSearch()}} />		
									</div>
								  </Grid>
								  
								</Grid>							  

							</div>

							<div style={{flex:1,width:"100%",backgroundColor:"#FFF"}}>
							
								<div className="card" style={{minHeight:"66vh",zIndex: 8,position:"relative"}}>

									<div className="registerModalIntro" style={{padding:"1rem",width:"70%"}}> Abaixo você encontra todos os direcionamentos efetivados para a sua empresa. Você pode visualizar mais informações selecionando o direcionamento desejado e realizar algumas ações disponíveis.</div>	

									<Divider />									
								
									<DataTable selectionMode="rowClick"

									onRowClick={(e) => selectLeadAction(e.data)}
																		
									lazy onPage={onPage}  emptyMessage="Nenhuma agência encontrada."
									onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
									onFilter={onFilter} filters={lazyState.filters} loading={loading} totalRecords={totalRecords}
									
									reorderableColumns reorderableRows stripedRows 
									onSelectionChange={(e) => selectLeadAction(e.value)} value={rows} paginator rows={lazyState.rows} rowsPerPageOptions={[10, 25]} tableStyle={{ minWidth: '50rem'}}>
		
										{/* Fixed column */}
										

            <Column field="leadId" header="ID" sortable style={{ width: '6rem' }} />
            <Column field="createdAt" header="Criado em" sortable body={(d) => bodyTemplate('createdAt', d)} style={{ width: '12rem' }} />
            <Column field="status" header="Status" sortable body={(d) => bodyTemplate('status', d)} style={{ width: '10rem' }} />

            <Column header="Cliente" body={(d) => bodyTemplate('customerName', d)} />
            <Column header="CPF" body={(d) => bodyTemplate('customerDocument', d)} style={{ width: '12rem' }} />

            <Column header="Serviço / Desconto" body={(d) => bodyTemplate('serviceOrDiscount', d)} style={{ width: '16rem' }} />
            <Column field="pricing.perLeadPrice" header="Valor" sortable body={(d) => bodyTemplate('perLeadPrice', d)} style={{ width: '10rem' }} />

            <Column header="Cidade/UF" body={(d) => bodyTemplate('city', d)} style={{ width: '14rem' }} />
            <Column field="targetType" header="Destino" sortable body={(d) => bodyTemplate('targetType', d)} style={{ width: '10rem' }} />
										
									</DataTable>
								</div>							
							
							</div>
						
						</div>
						
				</div>
			
			</div> 
		</div>

      {/* Modal */}
      <LeadModal
        dialog={dialog}
        setDialog={setDialog}
        selectedLead={selectedItem}
        retrieveLead={retrieveLead}
        masterUser={masterUser}
        userRights={userRights}
      /> 
		
    </div>
	
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  masterUser:store.appReducer.masterUser
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions,...PartnerActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(Leads);	


